import styled from 'styled-components';
import Link from 'gatsby-link';
import { rhythm } from '../../utils/typography'

const GatsbyLink = styled(Link)`
  color: #777;
  display: inline-block;
  font-size: ${rhythm(0.65)};
  margin: 0 10px;
  position: relative;
  text-decoration: none;
  box-shadow: none;
  border-bottom: none; 
  
  &:after {
    color: #007acc;
    background: #007acc;
    content: '';
    display: 'inline-block';
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    top: 100%;
    transition: 0.25s ease all;
    width: 0;
  }

  &:hover {
    text-decoration: none;
    color: #007acc;
    &:after {
      width: 100%;
    }
  }
`;

export default GatsbyLink;


// WEBPACK FOOTER //
// ./src/components/Nav/GatsbyLink.js